// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"6d88cd0a","659":"0081dfc3","963":"1f9b0613"}[chunkId] + ".chunk.css";
};